module.exports = __webpack_public_path__ + "assets/img/Travel_005.54e50085-ps.jpg";